export default {
    props: {
        mode: {
            type: String,
            default: "default"
        },
        canEdit: {
            type: Boolean,
            default: true
        },
        value: {
            type: Object,
            default () {
                return {};
            }
        },
        propsObj: {
            type: Object,
            default () {
                return {};
            }
        },
        isShare: Boolean
    },
    data () {
        return {};
    },
    computed: {
        finalCanEdit () {
            return this.$canEdit(this.canEdit, this.propsObj);
        },
        controlKey () {
            return this.propsObj._key;
        },
        inTable () {
            return !!this.propsObj.inTable;
        }
    },
    methods: {
        change (...params) {
            this.$emit("change", this.value[this.propsObj._key]);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/controls/controlMixin.js